import Model from './Model'
import Person from './Person'
import ImageContainer from '../Images/ImageContainer'

import game from '../Game/GameInstance'
import HoverMask from './HoverMask'
import BackgroundRenderer from './Rooms/BackgroundRenderer'
import StageRenderer from './Rooms/StageRenderer'
import TitleAndAttendeeBoxRenderer from './Rooms/TitleAndAttendeeBoxRenderer'
import ChildrenRenderer from './Rooms/ChildrenRenderer'
import EventDataRenderer from './Rooms/EventDataRenderer'
import PeoplePositioner from './Rooms/PeoplePositioner'
import ChildRoom from './ChildRoom'

export default class Room extends Model
{

  constructor(data) {

    let width = 300;
    let height = 300;

    let size = data.size ? data.size.toUpperCase() : 'L';

    switch(size) {
      case 'L':
        width = 630;
        height = 600;
        break;
      case 'M':
        width = 380;
        height = 460;
        break;
      case 'S':
        width = 300;
        height = 350;
        break;
    }

    super(width, height, data);

    this.size = size;

    this.backgroundRenderer = new BackgroundRenderer(this);
    this.stageRenderer = new StageRenderer(this);
    this.titleAndAttendeeBoxRenderer = new TitleAndAttendeeBoxRenderer(this);
    this.peoplePositioner = new PeoplePositioner(this);

    if (this.data.children && this.data.children.length) {
      this.childrenRenderer = new ChildrenRenderer(this);
    }

    this.eventDataRenderer = new EventDataRenderer(this);

    this.doorPoint = null;

    this.speakers = [];
    this.people = [];

    this.hoverMask = new HoverMask(this);

    if (this.data.speakers) {
      this.setSpeakers(this.data.speakers);
    }

    this.hasStage = (data.mode === 'stage');
    this.hasChildren = (data.mode === 'business');


    this.radius = this.scale(10);
    this.stageHeight = 75;
    this.stageArcHeight = Math.floor(width / 3);

    this.peopleNeedPositioning = false;
    this.personIndicator = null;

    this.view = 'people';
    this.waiters = [];

    if (this.data.children) {

      for (let i = 0; i < this.data.children.length; i++) {

        this.data.children[i] = new ChildRoom(this.data.children[i], this);

      }

      this.data.children.forEach(child => {
        if (child.image_url) {
          child.image = ImageContainer.getInstance().image(child.image_url);
          return;
        }
        child.image = null;
      });

    }


    if(this.data.mode === 'table'){
      if (this.data.image_url) {
        this.imageObject = ImageContainer.getInstance().image(this.data.image_url);

        this.imageObject.load().then((image) => {
          this.needsRendering = true;
        });
      }
    }

  }

  getDoorPoint() {
    return this.doorPoint;
  }

  getStage() {

    if (!this.hasStage) { return null; }
    if (game.view === 'speakers') { return null; }

    // this.stageHeight = 75;
    // this.stageArcHeight = Math.floor(width / 3);

    return {
      height: 75,
      arcHeight: this.width / 3
    };

  }

  draw(ctx) {

    this.backgroundRenderer.render(ctx);

    this.stageRenderer.render(ctx);

    this.titleAndAttendeeBoxRenderer.render(ctx);

    if (this.data.children && this.data.children.length) {
      this.childrenRenderer.render(ctx);
    }
    else{
      if( game.view === 'speakers' && this.data.mode !== 'lobby' ) {
        this.eventDataRenderer.render(ctx);
      }
    }

    this.peoplePositioner.render(ctx);

  }

  position() {

    super.position(...arguments);

    if (this.peopleNeedPositioning) {
      this.positionPeople();
      this.peopleNeedPositioning = false;
    }

  }

  addPerson(person, firstMove)
  {

    this.people.push(person);
    this.peopleNeedPositioning = true;
    this.needsRendering = true;

    if (this.data.mode === 'lobby') {
      person.startLobbyInteraction(this, firstMove);
      return;
    }

    if (this.hasHoverNameList) {
      let grid = this.getPeopleGrid();
      game.hoverNameList.setPeople(this.people.slice(grid.rows * grid.columns - 1));
    }

  }

  removePerson(person)
  {

    let i = this.people.length;
    while(i--) {
      if (this.people[i] === person) {
        // remove person
        this.people.splice(i, 1);
      }
    }

    this.peopleNeedPositioning = true;
    this.needsRendering = true;

    if (this.hasHoverNameList) {
      let grid = this.getPeopleGrid();
      game.hoverNameList.setPeople(this.people.slice(grid.rows * grid.columns - 1));
    }

  }


  positionPeople()
  {
    this.peoplePositioner.positionInGrid();

  }

  setSpeakers(speakers)
  {

    let speakerSize = 58;

    speakers.forEach(speaker => {
      speaker.model = new Person(speaker, speakerSize);
    });

    this.speakers = speakers;

  }



  multiLineText(ctx, text, width)
  {
    let lines = [];
    let currentLine = [];
    let words = text.split(/\s+/g);

    words.forEach(word => {

      let size = ctx.measureText(currentLine.join(' ') + ' ' + word);

      if (size.width < width) {
        currentLine.push(word);
        return;
      }

      size = ctx.measureText(currentLine.join(' '));

      lines.push({
        text : currentLine.join(' '),
        width : size.width
      });

      currentLine = [];

    });

    if (currentLine.length > 0) {

      let size = ctx.measureText(currentLine.join(' '));

      lines.push({
        text : currentLine.join(' '),
        width : size.width
      });

    }

    return lines;


  }

  updateWaiterCount() {

    let cnt = this.waiters.length;

    if (this.personIndicator) {

      if (cnt === 0) {
        this.personIndicator.hide();
        this.hoverMask.add('lobbyPersonIndicator').disable();

      }
      else{
        this.personIndicator.show();
        this.hoverMask.add('lobbyPersonIndicator', 15, this.height - 53, 38, 38).enable()
          .over(() => {

            let coordinate = game.mapCoordToScreenCoord(this.unscale(this.x) + 18, this.unscale(this.y) + this.height - 48);

            game.hoverNameList.setPeople(this.waiters.slice(0));

            // center
            game.hoverNameList.x = coordinate.x + 32 / 2;
            // bottom
            game.hoverNameList.y = coordinate.y + 32;
            game.hoverNameList.show();

            this.hoverMask.add('lobbyPersonDropdown', (15 + 38 / 2) - game.hoverNameList.width / 2, this.height - 53, game.hoverNameList.width, game.hoverNameList.height + 38)
              .repeat(true)
              .enable()
              .click((x, y) => {

                // console.log();
                game.hoverNameList.click(x, y - (this.height - 53));

              })
              .over((x, y) => {


              })
              .out(() => {
                game.hoverNameList.hide();
                this.hoverMask.remove(/lobbyPersonDropdown/);
              })


          })
          .out(() => {
            game.setToolTipText(null);
          });
      }

      this.personIndicator.setCount(cnt);

    }


  }

  garbageCollect() {

    this.personIndicator.garbageCollect();
    super.garbageCollect();

    if (this.data.children) {
      this.data.children.forEach((child) => {
        child.garbageCollect();
      })
      this.data.children.splice();
    }

    this.personIndicator = null;

    ['eventDataRenderer', 'backgroundRenderer', 'titleAndAttendeeBoxRenderer', 'peoplePositioner'].forEach((renderer) => {

      if (this[renderer].garbageCollect) {
        this[renderer].garbageCollect();
      }
      this[renderer] = null;

    });


    if (this.data.children && this.data.children.length) {

      this.data.children.forEach(child => {
        child.garbageCollect();
      });

      this.childrenRenderer =  null;

    }

    this.hoverMask.items.forEach((value, index, object) => {
      value.disable();

      object.splice(index, 1);
    })
  }

}
